import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import {
  ActiveEvaluationFeedbackCriteriaRequestModel,
  ActiveEvaluationFeedbackCriteriaResponseModel,
  DeleteEvaluationFeedbackCriteriaRequestModel,
  DeleteEvaluationFeedbackCriteriaResponseModel,
  GetEvaluationFeedbackCriteriaRequestModel,
  GetEvaluationFeedbackCriteriaResponseModel,
  InactiveEvaluationFeedbackCriteriaRequestModel,
  InactiveEvaluationFeedbackCriteriaResponseModel,
  ListEvaluationFeedbackCriteriaRequestModel,
  ListEvaluationFeedbackCriteriaResponseModel,
  SaveEvaluationFeedbackCriteriaRequestModel,
  SaveEvaluationFeedbackCriteriaResponseModel,
} from 'models/feedback/feedback.model';

export function listEvaluationFeedbackCriteria(
  payload: ListEvaluationFeedbackCriteriaRequestModel,
) {
  return authorizedRequest.get<
    ListEvaluationFeedbackCriteriaResponseModel,
    ListEvaluationFeedbackCriteriaResponseModel
  >(
    `${PREFIX_API.GENERAL}/feedback-evaluation-criterias?${preprocessGetQuery(
      payload,
    )}`,
  );
}

export function getEvaluationFeedbackCriteria(
  payload: GetEvaluationFeedbackCriteriaRequestModel,
) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetEvaluationFeedbackCriteriaResponseModel,
      GetEvaluationFeedbackCriteriaResponseModel
    >(`${PREFIX_API.GENERAL}/feedback-evaluation-criterias/${payload?.id}`);
  }
}

export function createEvaluationFeedbackCriteria(
  payload: SaveEvaluationFeedbackCriteriaRequestModel,
) {
  return authorizedRequest.post<
    SaveEvaluationFeedbackCriteriaResponseModel,
    SaveEvaluationFeedbackCriteriaResponseModel
  >(`${PREFIX_API.GENERAL}/feedback-evaluation-criterias`, payload);
}

export function updateEvaluationFeedbackCriteria(
  payload: SaveEvaluationFeedbackCriteriaRequestModel,
) {
  if (payload?.id) {
    return authorizedRequest.put<
      SaveEvaluationFeedbackCriteriaResponseModel,
      SaveEvaluationFeedbackCriteriaResponseModel
    >(
      `${PREFIX_API.GENERAL}/feedback-evaluation-criterias/${payload?.id}`,
      payload,
    );
  }
}

export function deleteEvaluationFeedbackCriteria(
  payload: DeleteEvaluationFeedbackCriteriaRequestModel,
) {
  return authorizedRequest.delete<
    DeleteEvaluationFeedbackCriteriaResponseModel,
    DeleteEvaluationFeedbackCriteriaResponseModel
  >(`${PREFIX_API.GENERAL}/feedback-evaluation-criterias/${payload?.id}`);
}

export function activeEvaluationFeedbackCriteria(
  payload: ActiveEvaluationFeedbackCriteriaRequestModel,
) {
  return authorizedRequest.put<
    ActiveEvaluationFeedbackCriteriaResponseModel,
    ActiveEvaluationFeedbackCriteriaResponseModel
  >(
    `${PREFIX_API.GENERAL}/feedback-evaluation-criterias/${
      payload?.id
    }/active?${preprocessGetQuery(payload)}`,
    payload,
  );
}

export function inactiveEvaluationFeedbackCriteria(
  payload: InactiveEvaluationFeedbackCriteriaRequestModel,
) {
  return authorizedRequest.put<
    InactiveEvaluationFeedbackCriteriaResponseModel,
    InactiveEvaluationFeedbackCriteriaResponseModel
  >(
    `${PREFIX_API.GENERAL}/feedback-evaluation-criterias/${
      payload?.id
    }/inactive?${preprocessGetQuery(payload)}`,
    payload,
  );
}
